// @ts-check
import getConfig from 'Util/Config';

const getMeasurementProtocolUrl = (measurementProtocol) =>
  measurementProtocol &&
  measurementProtocol.url &&
  measurementProtocol.id &&
  measurementProtocol.apiSecret
    ? measurementProtocol.url
        .replace('{measurement_id}', measurementProtocol.id)
        .replace('{api_secret}', measurementProtocol.apiSecret)
    : null;

/** @param {SendEventProps} props */
export default function sendEvent({ clientId, userId, userProperties, events }) {
  /** @type {{measurementProtocol: import('Util/Config').MeasurementProtocolConfig}} */
  const { measurementProtocol } = getConfig() || {};
  const measurementProtocolUrl = getMeasurementProtocolUrl(measurementProtocol);
  if (!measurementProtocolUrl) return;

  try {
    // measurement protocol payload document: https://developers.google.com/analytics/devguides/collection/protocol/ga4/reference?client_type=gtag#payload
    const measurementProtocolBody = {
      client_id: clientId,
      user_id: userId,
      non_personalized_ads: false,
      user_properties: userProperties,
      events: events,
    };

    fetch(measurementProtocolUrl, {
      method: 'POST',
      body: JSON.stringify(measurementProtocolBody),
    });
  } catch (e) {
    // by default GA4 does not return HTTP error codes
    // document: https://developers.google.com/analytics/devguides/collection/protocol/ga4/validating-events
    // do noting just catch to avoid interrupt app
  }
}

/**
 * @typedef MeasurementProtocolEvent
 * @property {string} name
 * @property {Record<string, any>} params
 */

/**
 * @typedef SendEventProps
 * @property {string} clientId
 * @property {string | undefined} userId
 * @property {Record<string, { value: string | undefined }>} userProperties
 * @property {MeasurementProtocolEvent[]} events
 */
